import mergeDeepRight from 'ramda/src/mergeDeepRight'
import { CAMERA_SELECTED_COLORS, WIRED_DEVICE_TYPES } from 'helpers/globals'

const defaults = {
  color: CAMERA_SELECTED_COLORS['blue'],
  location: {},
  locked: false,
  type: WIRED_DEVICE_TYPES[0].value,
  notes: '',
  nameTouched: false,
  manufacturer: '',
  model: ''
}

export const addWiredDeviceDefaults = mergeDeepRight(defaults)
export default defaults



// WEBPACK FOOTER //
// ./src/helpers/wiredDevices/defaults.js